// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"2b94a4d1","230":"c6dde045","244":"d2e9f15e","664":"9337b9ca","777":"24d64400"}[chunkId] + ".chunk.js";
};